import Constants from '../../utils/constants';
import { GET_CDP_NUMERIC_VALUE } from '../../utils/formulas';
import DefaultAmp from './default-amp';
import cloneDeep from 'lodash.clonedeep';

export default class VoltageReferenceAmp extends DefaultAmp {
  constructor() {
    super(...arguments);
  }

  clone() {
    // This needs to duplicate the code from default-amp to produce the right type of object
    const result = new VoltageReferenceAmp({
      cdpParameters: cloneDeep(this.cdpParameters),
      config: cloneDeep(this.config),
      resistor: this.resistor?.clone(),
      selected: cloneDeep(this.selected),
    });
    result.isCurrent = this.isCurrent;
    return result;
  }

  get selectedVout() {
    return this.getVout(this.selected);
  }

  getVout(voltageReference) {
    return GET_CDP_NUMERIC_VALUE(Constants.CDP.PARAMETERS.OUTPUT_VOLTAGE, voltageReference, this.cdpParameters);
  }
}
